import { render, staticRenderFns } from "./Questionstype.vue?vue&type=template&id=0dd86a08&scoped=true&"
import script from "./Questionstype.vue?vue&type=script&lang=js&"
export * from "./Questionstype.vue?vue&type=script&lang=js&"
import style0 from "./Questionstype.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./Questionstype.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Questionstype.vue?vue&type=style&index=2&id=0dd86a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd86a08",
  null
  
)

export default component.exports